import { render, staticRenderFns } from "./PointsMalle.vue?vue&type=template&id=33a529a8&scoped=true"
import script from "./PointsMalle.vue?vue&type=script&lang=js"
export * from "./PointsMalle.vue?vue&type=script&lang=js"
import style0 from "./PointsMalle.vue?vue&type=style&index=0&id=33a529a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a529a8",
  null
  
)

export default component.exports